import { render, staticRenderFns } from "./planTable.vue?vue&type=template&id=a96d7ff6&scoped=true"
import script from "./planTable.vue?vue&type=script&lang=js"
export * from "./planTable.vue?vue&type=script&lang=js"
import style0 from "./planTable.vue?vue&type=style&index=0&id=a96d7ff6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96d7ff6",
  null
  
)

export default component.exports